import { Key, useContext } from 'react';
import { FilterContext } from 'utils/context';
import DK from 'utils/dictionaries/filter_dictionary';

import { Select, SelectItem, TableCell } from '@project44/manifest-ds';
import { Skeleton } from '@project44/shared-components';
import { useTranslation } from '@project44/translations-utils';

const styles = {
  base: {
    backgroundColor: '$background-primary',
    boxShadow: 'inset 0 -1px 0 0 #E4E6E7', // $border-primary
    color: '$text-tertiary',
    fontWeight: '600',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '&:first-of-type': {
      boxShadow: 'inset -1px -1px 0 0 #E4E6E7', // $border-primary
      left: 0,
      zIndex: 3,
    },
  },
  select: {
    '& button': {
      border: 'none !important',
      '& span': {
        fontWeight: '600',
      },
    },
  },
};

interface ICellHeader {
  isLoading: boolean;
  title: string;
  disabled?: boolean;
  doSearch?: () => void;
  options?: Array<{ displayLabel?: string; label: string; value: string }>;
}

export function CellHeader({
  disabled = false,
  doSearch,
  isLoading,
  options,
  title,
}: ICellHeader) {
  const { filters, setFiltersKey } = useContext(FilterContext);
  const filter = (filters[DK.SORT_BY] as string[]) || [];
  const selected = options?.find(({ value }) => value === filter.join('/'));
  const { t } = useTranslation();

  const handleChange = (value: Key) => {
    setFiltersKey(DK.SORT_BY, ('' + value).split('/'));
    doSearch && doSearch();
  };

  const content = !options ? (
    title
  ) : (
    <Select
      aria-label={t('common.sortColumn', { columnName: title })}
      css={styles.select}
      size="small"
      isDisabled={disabled}
      onSelectionChange={handleChange}
      placeholder={title}
      selectedKey={selected?.value || ''}
      children={options.map((opt) => (
        <SelectItem key={opt.value} aria-label={opt.value}>
          {opt.displayLabel}
        </SelectItem>
      ))}
    />
  );

  return (
    <TableCell css={styles.base}>
      {isLoading ? <Skeleton css={{ height: 34, minWidth: 150 }} /> : content}
    </TableCell>
  );
}

export default CellHeader;
